import React from 'react';

import moment from 'moment';
import 'moment/locale/en-gb';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import MaskedInput from 'react-text-mask';

import FormbuilderFieldWrapper from './formbuilderFieldWrapper';

import { DEFAULT_DATE_FORMAT } from '../../../constants';
import { DATE_MASK } from '../../../constants/masks';

import './index.css';

class FormbuilderDatePicker extends React.Component {
    componentDidMount() {
        const date = this.props.value;
        if (date && moment(date).isValid()) {
            setTimeout(() => {
                this.props.onChange(moment(date).format(DEFAULT_DATE_FORMAT));
            }, 0);
        }
    }

    onChange = (date) => {
        this.props.onChange(moment(date).isValid() ? date.format(DEFAULT_DATE_FORMAT) : date);
    }

    onChangeRaw = (text) => {
        this.props.onChange(text);
    }

    getSelectedValue = (value) => {
        if (value && moment(value).isValid()) {
            return moment(value);
        }
        return undefined;
    }

    render() {
        const { value, identifier, placeholder, label, validation, error, errorMessage, onBlur, inputSub, popup, initialValidation } = this.props;
        const selectedValue = this.getSelectedValue(value);

        return (
            <FormbuilderFieldWrapper label={label}
                key={identifier}
                validation={validation}
                error={error}
                errorMessage={errorMessage}
                onBlur={onBlur}
                inputSub={inputSub}
                popup={popup}
                value={value}
                initialValidation={initialValidation}>
                <DatePicker id='formbuilder-datepicker'
                    onChange={this.onChange}
                    onChangeRaw={(event) => this.onChangeRaw(event.target.value)}
                    selected={selectedValue}
                    value={selectedValue ? undefined : value}
                    placeholderText={placeholder}
                    showYearDropdown
                    dropdownMode="select"
                    customInput={
                        <MaskedInput
                            mask={DATE_MASK}
                            pattern="[0-9]*"
                            inputMode="numeric"
                        />
                    }
                />
            </FormbuilderFieldWrapper>
        );
    }
}

export default FormbuilderDatePicker;